import { QueryResult } from "@apollo/client";
import React from "react";
import { SidebarFilters, SidebarFiltersVariables } from "types/gql-types";

type Context = null | QueryResult<SidebarFilters, SidebarFiltersVariables>;

const TableContext = React.createContext<Context>(null);

export default TableContext;
